// Static data for MBK Holding website

export const BRAND = {
  name: 'MBK Holding',
  tagline: 'Sovereign capital, engineered for Qatar\'s future.',
  arabic: 'مَجْمُوعَة',
  logo: '/mbk-logo.png',
  contact: {
    address: 'P.O Box: 11824, AAB Tower, 8th Floor, Office No. 804, C-Ring Road',
    city: 'Doha — State of Qatar',
    phone: '+974 4467 9005',
    emailFinance: 'finance@mbkholding.qa',
    emailInquiry: 'amer@mbkholding.qa',
    site: 'www.mbkholding.qa',
  },
};

export const NAV_LINKS = [
  { label: 'About', to: '/about' },
  { label: 'Strategy', to: '/strategy' },
  { label: 'Ventures', to: '/ventures' },
  { label: 'Services', to: '/services' },
  { label: 'Security', to: '/security' },
  { label: 'Contact', to: '/contact' },
];

export const PRINCIPLES = [
  {
    arabic: 'أَمَانَة',
    title: 'Amāna — Sovereign Trust',
    text: 'The sacred deposit. The obligation a custodian owes to those who place wealth, craft and reputation in our care. Every relationship begins here — before spreadsheets, before contracts.',
  },
  {
    arabic: 'إِتْقَان',
    title: 'Itqān — Industrial Mastery',
    text: 'The discipline of perfecting one\'s craft. We back operators who treat their work as devotion — and let that excellence become the moat that compounds for decades.',
  },
  {
    arabic: 'عَدْل',
    title: 'ʿAdl — Enduring Fairness',
    text: 'Equitable outcome — to founders, to operators, to limited partners, and to the next generation that inherits what we build. Returns are durable only when every party leaves the table whole.',
  },
];

// Subsidiaries from mbkholding.co.uk
export const SUBSIDIARIES = [
  { name: 'Entelyst', sector: 'Technology Consulting', url: 'https://entelyst.com.qa/' },
  { name: 'Go-Viral', sector: 'Digital Marketing', url: '#' },
  { name: 'Hill+Knowlton', sector: 'Strategic Communications', url: 'https://www.hkstrategies.com/en/' },
  { name: 'MBK Consulting', sector: 'Management Advisory', url: 'https://www.mbk-consulting.com/' },
  { name: 'PlayBuddy', sector: 'Sports Technology', url: 'https://www.goplaybuddy.com/' },
  { name: 'Qatar Aviation', sector: 'Aviation Services', url: 'https://www.qataraviation.com/page/home' },
  { name: 'Quantum SS', sector: 'Security Systems', url: 'https://www.quantumss.com/' },
  { name: 'The Professional Hobbies', sector: 'Lifestyle Retail', url: 'http://www.theprohobbies.com/' },
  { name: 'Anvin', sector: 'Industrial Services', url: 'https://anvinqatar.com/' },
  { name: 'BIMS Group', sector: 'Building Technology', url: 'https://www.bimsgroup.com/' },
  { name: 'Braincert', sector: 'EdTech / LMS', url: 'https://www.braincert.com/' },
];

// M³ Holdings Group ventures (under MBK patronage)
export const M3_VENTURES = [
  { name: 'Toothrocket', arabic: 'صَنْعَة', sector: 'Digital Dental Manufacturing', status: 'Operations', blurb: 'SLA-printed clinical devices manufactured at clinical-grade tolerance — the physical spine of the dental group.', url: 'https://toothrocket.com/' },
  { name: 'Toothmatrix', arabic: 'نِظَام', sector: 'Clinical SaaS Platform', status: 'Operations', blurb: 'The software spine of Toothrocket. Subscription platform that digitises intake, scans, orders and case management.', url: 'https://toothrocket.com/toothmatrix' },
  { name: 'Vigilant Entities', arabic: 'حَوْكَمَة', sector: 'Governance · Risk · Venture Platform', status: 'Operations', blurb: 'Vigilance. Governance. Growth. The institutional operating system for sovereign holdings — twelve sectors, a rotating advisory council and twenty-six AI officers vetting founders, investors and ventures with audit-grade discipline.', url: 'https://vigilantentities.com/' },
  { name: 'Q-Bone Precision', arabic: 'دِقَّة', sector: 'Precision Bio-Manufacturing', status: 'Concept', blurb: 'Precision bone and surgical guides produced at clinical-grade tolerances — built for the operating room.', url: '#' },
  { name: 'DentistsOnWheels', arabic: 'سَيْر', sector: 'Mobile Clinical Networks', status: 'Concept', blurb: 'Mobile dental units that bring high-margin digital workflows to underserved geographies. Logistics as a clinical product.', url: '#' },
  { name: 'AeroForge 3D', arabic: 'تَشْكِيل', sector: 'Aerospace Additive Manufacturing', status: 'Concept', blurb: 'Aerospace-grade additive manufacturing — light alloys, complex geometries, certified throughput.', url: '#' },
];

export const PORTFOLIO_COMPANIES = [
  'Bolt Global', 'BYP', 'Cwallet', 'Debito', 'Else', 'Festiie', 'Intellibonds',
  'Angel.qa', 'Manigo', 'Milo', 'QCloud', 'Qewam', 'Seeloz', 'Snoonu', 'StorFund', 'Vesuvio',
];

export const SERVICES = [
  {
    number: '01',
    title: 'Global Entrepreneurial Ecosystem Building',
    blurb: 'An interconnected architecture of capital, talent and policy access. We build the rails entrepreneurs scale on.',
    bullets: ['Strategic partnership identification', 'Global leadership policy dialog', 'Monetisation & benefits realisation', 'Talent identification & exchange'],
  },
  {
    number: '02',
    title: 'VC-as-a-Service (VCaaS)',
    blurb: 'MBK acts as your venture arm — institutional-grade sourcing, underwriting and portfolio stewardship for sovereigns, family offices and corporates.',
    bullets: ['Goal-based sourcing', 'Institutional underwriting process', 'Portfolio governance', 'Corporate-venture alignment'],
  },
  {
    number: '03',
    title: 'Start-ups Performance Improvement',
    blurb: 'Eight in ten software start-ups fail. We build the operating discipline that gets the other two to scale.',
    bullets: ['Operator mentorship', 'Market access programs', 'Technology & back-office support', 'Talent outsourcing'],
  },
  {
    number: '04',
    title: 'Digital Transformation',
    blurb: 'Rethinking how organisations use technology, people and processes — engineered for new revenue models and modern governance.',
    bullets: ['Enterprise architecture', 'ERP / CRM / Custom development', 'AI audit & advanced analytics', 'Cybersecurity & infrastructure modernisation'],
  },
];

export const MANAGEMENT = [
  { name: 'H.E. Sheikh Mansoor Bin Khalifa Al Thani', role: 'Chairman', arabic: 'مَعَالِي الشَّيْخ' },
  { name: 'Sheikh Khalifa Bin Mansoor Al Thani', role: 'Vice-Chairman', arabic: 'الشَّيْخ' },
  { name: 'Dileep Balakrishnan', role: 'Group CEO', arabic: '' },
  { name: 'Rojar Nadado', role: 'Internal Audit & Finance Control', arabic: '' },
];

export const ADVISORY = [
  { name: 'Fazil Rahim' },
  { name: 'Ayman Adhair' },
  { name: 'Kristian Feldborg' },
  { name: 'Ali Al Saada' },
  { name: 'Nazmath Nazeer' },
];

// QNDS3 — the seven national outcomes
export const QNDS3_PILLARS = [
  {
    n: '01',
    arabic: 'نُمُوّ',
    title: 'Sustainable Economic Growth',
    text: 'Transform Qatar into a competitive, productive, diversified and innovative economy — focused on high-productivity specialised clusters.',
  },
  {
    n: '02',
    arabic: 'مَالِيَّة',
    title: 'Fiscal Sustainability',
    text: 'Strengthen the long-term stability, health and resilience of the government budget and its balance sheet.',
  },
  {
    n: '03',
    arabic: 'كَفَاءَة',
    title: 'Future-ready Workforce',
    text: 'Develop Qataris into globally competitive individuals; attract high-skilled expatriates as long-term partners in the transformation.',
  },
  {
    n: '04',
    arabic: 'تَلَاحُم',
    title: 'Cohesive Society',
    text: 'Preserve Qatari values and family bonds while fostering active citizenship and a harmonious integrated community.',
  },
  {
    n: '05',
    arabic: 'حَيَاة',
    title: 'Quality of Life',
    text: 'Quality of life through excellence in healthcare and public safety with a vibrant cultural and family environment.',
  },
  {
    n: '06',
    arabic: 'بِيئَة',
    title: 'Environmental Sustainability',
    text: 'Conserve natural resources, protect ecosystems, reduce GHG emissions, and build resilience against environmental risk.',
  },
  {
    n: '07',
    arabic: 'حَوْكَمَة',
    title: 'Government Excellence',
    text: 'Become a world-class provider of public services and a top nation for effective, efficient and transparent governance.',
  },
];

// How MBK ventures map to NDS3 clusters
export const CLUSTER_MAP = [
  {
    cluster: 'Advanced Manufacturing Cluster',
    arabic: 'صِنَاعَة',
    desc: 'Specialised, high-productivity clusters and downstream products with global competitive advantage.',
    ventures: ['AeroForge 3D', 'Toothrocket', 'BIMS Group'],
  },
  {
    cluster: 'IT & Digital Services Cluster',
    arabic: 'رَقْمَنَة',
    desc: 'Driving Qatar\'s digital economy and long-term capabilities in AI and emerging technologies.',
    ventures: ['Toothmatrix', 'Entelyst', 'Braincert', 'QCloud'],
  },
  {
    cluster: 'Healthcare Cluster',
    arabic: 'صِحَّة',
    desc: 'Long-term specialisations in precision medicine, MedTech and clinical-grade manufacturing.',
    ventures: ['Toothrocket', 'Toothmatrix', 'Q-Bone Precision', 'DentistsOnWheels'],
  },
  {
    cluster: 'Government Excellence & Public Safety',
    arabic: 'حَوْكَمَة',
    desc: 'Strengthened institutional governance, cyber resilience and public-safety capabilities.',
    ventures: ['Vigilant Entities', 'Quantum SS', 'MBK Consulting'],
  },
];

export const COMMITMENTS = [
  { arabic: 'تَوْطِين', title: 'Tawṭīn — Localisation', text: 'Capacity, jobs and IP anchored inside Qatar — not exported back into the country as imports.' },
  { arabic: 'تَنْوِيع', title: 'Tanwīʿ — Diversification', text: 'Capital deployed away from hydrocarbon dependency into knowledge-led, productivity-advancing industries.' },
  { arabic: 'كَفَاءَة', title: 'Kafāʾa — Talent', text: 'Qatari operators upskilled, complemented by high-skilled international talent — a future-ready workforce.' },
];

export const SECURITY_PILLARS = [
  {
    code: 'ISO/IEC 27001',
    title: 'Information Security Management',
    text: 'Information Security Management System aligned to ISO/IEC 27001 — controls audited and continuously improved.',
  },
  {
    code: 'SOC 2 Type II',
    title: 'Audited Operational Trust',
    text: 'Vendor and platform operations evaluated for security, availability, processing integrity, confidentiality and privacy.',
  },
  {
    code: 'AES-256',
    title: 'Encryption at Rest & in Transit',
    text: 'AES-256 encryption at rest, TLS 1.3 in transit. Customer-managed keys available for enterprise mandates.',
  },
  {
    code: 'Zero-Trust',
    title: 'Zero-Trust Architecture',
    text: 'No implicit trust. Identity-aware proxies, hardware-token MFA, least-privilege access, continuous device posture.',
  },
  {
    code: 'GDPR / PDPPL',
    title: 'Regulatory Compliance',
    text: 'Compliant with Qatar\'s PDPPL (Law 13/2016), GDPR, and international banking data handling standards.',
  },
  {
    code: '24/7 SOC',
    title: 'Security Operations Centre',
    text: 'Round-the-clock monitoring, threat hunting, incident response and adversarial red-team simulations.',
  },
];

export const STATS = [
  { value: '27+', label: 'Subsidiaries & ventures' },
  { value: '16+', label: 'Portfolio companies' },
  { value: '4', label: 'NDS3 clusters served' },
  { value: 'Doha', label: 'To the world' },
];
